// extracted by mini-css-extract-plugin
export default {"onlyImage":"scheme_onlyImage__bii4d"};